/**
 * Reserved routes that should not be treated as SO numbers
 * These routes are handled by the application routing system
 */
export const RESERVED_ROUTES = ['admin', 'sales', 'login', 'logout', 'settings', 'help'];